module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrap"
  }, _vm._l((_vm.task_union), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "routerlink"
    }, [_c('a', [_vm._v("\n                " + _vm._s(item.union_number) + " - " + _vm._s(item.union_task_name) + "\n            ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2124975e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/read-relation.vue
// module id = 709
// module chunks = 1